import Spinner from './LoadingSpinner';

export default Spinner;
